











































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Getter, Action } from 'vuex-class';
import { DEPLOYMENT_UPDATE_SELECTED_DEPLOYMENT } from '@/store/mutypes';
import {
  Deployment,
  Service,
  ServiceVersion,
  Cluster,
  Response,
  DeployDTO
} from '@/types';
import Constants from '@/constants';
import { Notification } from 'element-ui';
import DeploymentValuesEditor from './DeploymentValuesEditor.vue';

@Component({
  name: 'deploy-dialog',
  components: {
    DeploymentValuesEditor
  }
})
export default class DeployDialog extends Vue {
  versionId: string = '0';
  clusterId: string = '0';
  forceUpgrade: boolean = false;
  showDeployDialog: boolean = false;
  versions: ServiceVersion[] = [];
  clusters: Cluster[] = [];
  service!: Service;
  showDeploymentValuesEditorDialog: boolean = false;
  isLoading: boolean = false;

  @State(s => s.DeploymentMod.selectedDeployment)
  selectedDeployment!: Deployment;

  @Getter
  getServiceById!: (id: string) => Service;

  @Watch('selectedDeployment')
  onSelectedDeploymentUpdate(selectedDeployment: Deployment) {
    if (selectedDeployment) {
      this.service = this.getServiceById(selectedDeployment.service.id);

      this.versions = this.service.versions;

      this.clusters = selectedDeployment.cluster
        ? [selectedDeployment.cluster]
        : this.service.clusters;

      this.versionId = selectedDeployment.version
        ? selectedDeployment.version.id
        : this.versions[0].id;

      this.clusterId = selectedDeployment.cluster
        ? selectedDeployment.cluster.id
        : this.clusters[0].id;

      this.showDeployDialog = !!selectedDeployment;
    }
  }

  @Action
  deploy!: (dto: DeployDTO) => Response;

  closeDialog() {
    this.showDeployDialog = false;
    this.$store.commit(DEPLOYMENT_UPDATE_SELECTED_DEPLOYMENT, undefined);
  }

  async onConfirm() {
    this.isLoading = true;
    try {
      await this.deploy({
        deploymentId: this.selectedDeployment.id,
        clusterId: this.clusterId,
        versionId: this.versionId,
        forceUpgrade: this.forceUpgrade
      });
      Notification.info(
        'Instance is deploying. It takes about 1 minute, refresh this page later to check the status.'
      );
    } catch (e) {
      this.$notify.error('Failed to deploy.');
    }
    this.isLoading = false;
    this.closeDialog();
  }
}
